import './specific.css'
import React from 'react';
import p from '../pictures/Image 577.png'
import p1 from '../pictures/Expand.png'
import p2 from '../pictures/pdf@2x.png'
function Specific() {
    return (
        <div className="whole12">
            <div className="titleSpecific">Specifications</div>
            <div className="inspired">Feel Inspired By Aesthetic Interiors</div>
            <div className="inspireText"><p>Located off the Golf Course Extension Road, sans traffic and dust,
            with direct connectivity from both Delhi and Gurugram, Elevate enjoys lush views of the Aravallis
                in a premium upscale neighbourhood.</p>
            </div>
            <div class="lineHorizontal__container_second">
            </div>
            <div className="master">Master Bedroom / Dress room</div>
            <div className="living1">Living / dining / study</div>
            <div className="living2">Living / dining / study</div>
            <div className="living3">Living / dining / study</div>
            <div class="lineHorizontal__container_second1">
            </div>
            <div class="lineHorizontal__container_second2">
            </div>
            <div className="img_577">
                <img src={p} alt="" />
            </div>
            <div className="dressRoom">Master bed room / dress room</div>
            <div className="full">
                <ol>
                    <li>Floor</li>
                    <div className="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <li>Wall</li>
                    <div className="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                    <li>Celling</li>
                    <div className="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
                </ol>
            </div>
            <div className="floorPlan">
                <img src={p1} alt="" />
                <div>Download Floor Plan</div>
            </div>
            <div className="brochure">
                <img src={p2} alt="" />
                <div>Download Brochure</div>
            </div>
        </div>
    );
}

export default Specific